import script from "./RoomsRatesSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoomsRatesSection.vue?vue&type=script&setup=true&lang=ts"

import "./RoomsRatesSection.vue?vue&type=style&index=0&id=434fac2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-434fac2e"]])

export default __exports__